export const ID = 'KFMYBKHBBH'
export const KEY = '752fe759ce6b0914036f48c09e3a5d6e'

export const KEYWRITE = 'd2431e2f68f07b4280f459085b2f55fc'